import React from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Container,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import AllItemRequests from "../../../../components/Transfers/Items/AllItemRequests";

const OrdersFromCentralStore = (props) => {
  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
        <Breadcrumb_2Items
            title={props.t("Transfer")}
            alternateTitle={props.t("All Requests")}
            breadcrumbItem1={props.t("All Item Requests")}
          />
      
        <AllItemRequests />
        
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(OrdersFromCentralStore))
);
